import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {Form, Input} from 'antd';
import {validation} from '../../../../../utils/validation';

const {Item} = Form;

const formFieldProps = {
  size: 'large'
}

const BankingVendorFormItems = () => {
  const [t] = useTranslation(['main', 'vendors']);

  const validationRules = useMemo(() => ({
    bic: validation.bic(t, false),
    iban: validation.iban(t, false),
  }), [t]);

  const trans = (key) => t(`vendors:${key}`);

  const formT = (key) => trans(`modal.addVendor.${key}`);

  const placeholder = (key) => formT(`placeholder.${key}`);

  return (
    <>
      <Item
        label={t('iban')}
        name='iban'
        rules={validationRules.iban}
      >
        <Input
          {...formFieldProps}
          placeholder={placeholder('iban')}
        />
      </Item>
      <Item
        label={t('bic/swift')}
        name='bic'
        rules={validationRules.bic}
      >
        <Input
          {...formFieldProps}
          placeholder={placeholder('bic')}
        />
      </Item>
    </>
  );
}

export default BankingVendorFormItems;
